import { Grid, TextField, MenuItem, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { perguntaVisivel } from "../utils/questionario";

// Renderiza os campos de uma seção do questionário, escondendo perguntas
// condicionais cujo gatilho não foi atingido.
export default function QuestionarioCampos({ perguntas, respostas, setResp, byCodigo }) {
  const visiveis = perguntas.filter((p) => perguntaVisivel(p, respostas, byCodigo));
  if (visiveis.length === 0)
    return <Typography variant="body2" color="text.secondary">Nada a preencher nesta seção.</Typography>;

  return (
    <Grid container spacing={2}>
      {visiveis.map((p) => (
        <Grid key={p.Id} size={{ xs: 12, sm: p.TipoResposta === "texto" ? 12 : 6 }}>
          {p.TipoResposta === "bool" ? (
            <FormControlLabel
              control={<Checkbox checked={!!respostas[p.Id]} onChange={(e) => setResp(p.Id, e.target.checked)} />}
              label={p.Enunciado} />
          ) : p.TipoResposta === "selecao" || p.TipoResposta === "multipla" ? (
            <TextField select fullWidth required={p.Obrigatoria} label={p.Enunciado} value={respostas[p.Id] || ""} onChange={(e) => setResp(p.Id, e.target.value)}>
              {(p.Opcoes || []).map((o) => <MenuItem key={o.Id} value={o.Id}>{o.Rotulo}</MenuItem>)}
            </TextField>
          ) : p.TipoResposta === "int" || p.TipoResposta === "decimal" ? (
            <TextField type="number" fullWidth required={p.Obrigatoria} label={p.Enunciado} value={respostas[p.Id] ?? ""} onChange={(e) => setResp(p.Id, e.target.value)} />
          ) : p.TipoResposta === "data" ? (
            <TextField type="date" fullWidth required={p.Obrigatoria} label={p.Enunciado} InputLabelProps={{ shrink: true }} value={respostas[p.Id] || ""} onChange={(e) => setResp(p.Id, e.target.value)} />
          ) : (
            <TextField fullWidth multiline required={p.Obrigatoria} label={p.Enunciado} value={respostas[p.Id] || ""} onChange={(e) => setResp(p.Id, e.target.value)} />
          )}
        </Grid>
      ))}
    </Grid>
  );
}
